import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const GlobalBrandView = () => {
  const [GlobalBrandUser, setGlobalBrandUser] = useState({
    global_brand_image: "",
    brand_logo:"",
    discount: ""
  });
  const { id } = useParams();

  useEffect(() => {
    const GlobalBrandData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_global_brand_by_id",
          {
            brand_id: id
          }
        );
        setGlobalBrandUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    GlobalBrandData();
  }, [id]);

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories View</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card GlobalBrand-view">
            <div className="cross-icon">
              <Link to="/GlobalBrand">
              <i className="fa-solid fa-circle-xmark"></i>
              </Link>
            </div>
              <div>
                <img
                  src={`https://cyberathon.com/multivendor/${GlobalBrandUser.global_brand_image}`}
                  width={600} height={400}
                  // style={{paddingRight: '10px'}}
                />
                <img
                  src={`https://cyberathon.com/multivendor/${GlobalBrandUser.brand_logo}`}
                  width={600} height={400}
                />
              </div>
              <strong>Discount</strong>
              <p>{GlobalBrandUser.discount}</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default GlobalBrandView;
